import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SftGlobalData from '../../library/SftGlobalData';
import axios from 'axios';
import { DataGridPro, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid-pro';
import LicenceCheckBox from '../../components/licence/LicenceCheckBox';
import { Box, Button, FormControl, InputLabel, MenuItem, Paper, Select, Stack, Tab, Tabs, styled } from '@mui/material';
import { faPencilAlt, faPlay } from '@fortawesome/free-solid-svg-icons';
import Colors from '../../library/Colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DeleteIcon from '@mui/icons-material/Delete';
import PropTypes from 'prop-types';
import { PlayArrow } from '@mui/icons-material';

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <div style={{padding: 5, paddingTop: 10}}>{children}</div>
          </Box>
        )}
      </div>
    );
  }
  
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};
  
const a11yProps = (index) => {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
  }

let customerRow = {};

const SchedulerScreen = (props) =>  {  
    const [loading, setLoading] = useState(true);
    const [users, setUsers] = useState([]);
    const [reports, setReports] = useState([]);
    const [openDetailPanelRowId, setOpenDetailPanelRowId] = useState([]);
    const [selectedUser, setSelectedUser] = useState("");
    let navigate = useNavigate();
    const apiRef = useGridApiRef();
    const gridColumns = [
        {
            field: 'id',
            headerName: "ID",
            headerAlign: "center",
            width: 75,
            align: "center",
        },
        {
            field: 'report_id',
            headerName: "Rep ID",
            headerAlign: "center",
            width: 75,
            align: "center",
        },
        {
            field: 'name',
            headerName: "Report",
            headerClassName: 'bold',
            minWidth: 250,
            width: 700,
            align: "left",
        },
        {
            field: 'type',
            headerName: "Type",
            headerClassName: 'bold',
            minWidth: 100,
            width: 100,
            align: "left",
        },
        {
            field: 'count',
            headerName: "# Users",
            headerClassName: 'bold',
            minWidth: 100,
            width: 100,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'next_run',
            headerName: "Next run",
            headerClassName: 'bold',
            minWidth: 200,
            width: 200,
            align: "left",
        },
        {
            field: 'actions',
            type: 'actions',
            width: 40,
            maxWidth: 40,
            minWidth: 40,
            display: 'flex',
            getActions: (params) => [
                params.row.allow_next_run !== 'T' ? <div></div> : <GridActionsCellItem
                icon={<PlayArrow  sx={{ color: Colors.def_green }} />}
                label="Run now"
                onClick={()=>{if(SftGlobalData.confirmWindow(props.t('are_you_sure_you_want_to_run_now'))){runReportNow(params.row.id);}}}
              />
            ],
        },
    ];

    const DetailPanelContent = ( row ) => {
        customerRow = row.row;
        return (
            <Stack
            key={row.row.id}
            sx={{ py: 1, height: '100%', boxSizing: 'border-box' }}
            direction="column"
            >
                <Paper sx={{ flex: 1, mx: 'auto', width: '95%', p: 1 }}>
                    <Stack direction="column" spacing={1} sx={{ height: 1 }}>
                        <div className='rowContainerBetween' style={{ flex: 1, width: "100%" }}>
                            <DataGridPro
                              density="compact"
                              columns={
                                row.row.count > 1 ?
                                [
                                    { 
                                        field: 'id', 
                                        headerName: 'User ID', 
                                        headerClassName: 'bold',
                                        width: 75,
                                        align: "left",
                                        display: 'flex',
                                    },
                                    { 
                                        field: 'user_name', 
                                        headerName: 'Name', 
                                        headerClassName: 'bold',
                                        minWidth: 175,
                                        width: 250,
                                        align: "left",
                                        display: 'flex',
                                    },
                                    { 
                                        field: 'email', 
                                        headerName: 'Email', 
                                        headerClassName: 'bold',
                                        minWidth: 175,
                                        width: 250,
                                        align: "left",
                                        display: 'flex',
                                    },
                                    {
                                        field: 'actions',
                                        type: 'actions',
                                        width: 40,
                                        maxWidth: 40,
                                        minWidth: 40,
                                        display: 'flex',
                                        getActions: (params) => [
                                            props.disabled ? <div></div> : <GridActionsCellItem
                                            icon={<DeleteIcon  sx={{ color: Colors.def_red }} />}
                                            label="Remove"
                                            onClick={()=>{deleteUser(params.row.id, params.row.scheduleId, params.row.email);}}
                                          />
                                        ],
                                    },
                                ] :
                                [
                                    { 
                                        field: 'id', 
                                        headerName: 'User ID', 
                                        headerClassName: 'bold',
                                        width: 75,
                                        align: "left",
                                        display: 'flex',
                                    },
                                    { 
                                        field: 'user_name', 
                                        headerName: 'Name', 
                                        headerClassName: 'bold',
                                        minWidth: 175,
                                        width: 250,
                                        align: "left",
                                        display: 'flex',
                                    },
                                    { 
                                        field: 'email', 
                                        headerName: 'Email', 
                                        headerClassName: 'bold',
                                        minWidth: 175,
                                        width: 250,
                                        align: "left",
                                        display: 'flex',
                                    }
                                ]}
                              rows={row.row.users.map((user, index) => {return {
                                    id: user.id,
                                    user_name: user.user_name,
                                    email: user.email,
                                    scheduleId: row.row.id
                                }                          
                                })}
                              style={{flex: 1, heigth: "100%"}}
                              hideFooter
                            />
                        </div>
                        <div className='rowContainerBetween' style={{ width: "100%" }}>
                            <FormControl className={props.theme + '_accent _90perc'}>
                                <InputLabel id="demo-simple-select-label">User</InputLabel>
                                <Select
                                    className={props.theme + "_accent " + props.theme + "_text _100perc"}
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={selectedUser}
                                    label="User"
                                    onChange={(event) => setSelectedUser(event.target.value)}
                                    style={{ }}>
                                    <MenuItem value="">-</MenuItem>
                                    {users.filter(user => !row.row.users.some(rowUser => rowUser.id === user.id)).map((user) => (
                                        <MenuItem key={user.id} value={user.id}>{user.email} ({user.id} - {user.user_name})</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <Button className="modal_button_container_no_margin_total__button" style={{height: 56}} onClick={()=>{addUser(selectedUser, row.row.id); setSelectedUser("");}}>{props.t("add")}</Button>
                        </div>

                        
                    </Stack>
                </Paper>
            </Stack>
        );
    }

    useEffect(() => {
        loadData();
        props.changeScreen('Licence');
    },[props.api]);

    const loadData = () => {
        if(props.api === "") return;
        setLoading(true);
        SftGlobalData.post('scheduler&action=fetch', {key: props.api}).then(response => {
            if(typeof response.error === 'undefined'){
                if(typeof response.data !== "undefined") {
                    setReports(response.data.schedules);
                    setUsers(response.data.users);
                }
            } else { 
                props.notify(props.t('errorOccured'), 7500, "top-center", props.theme, 1);
            }
            setLoading(false);
        });
    }

    const deleteUser = (userId, scheduleId, email) => {
        setLoading(true);
        let postData = {
            key: props.api,
            user_id: userId,
            schedule_id: scheduleId,
            email: email
        };
        SftGlobalData.post('scheduler&action=deleteUser', postData).then(response => {
            if(typeof response.error === 'undefined'){
                loadData();
            } else { 
                props.notify(props.t('errorOccured'), 7500, "top-center", props.theme, 1);
            }
        });
    }

    const addUser = (userId, scheduleId) => {
        if(userId !== ""){
            setLoading(true);
            const user = users.find(user => user.id === userId);
            let email = user ? user.email : "";
            let postData = {
                key: props.api,
                user_id: userId,
                schedule_id: scheduleId,
                email: email
            };
            SftGlobalData.post('scheduler&action=addUser', postData).then(response => {
                if(typeof response.error === 'undefined'){
                    loadData();
                } else { 
                    props.notify(props.t('errorOccured'), 7500, "top-center", props.theme, 1);
                }
            });
        }
    }

    const runReportNow = (scheduleId) => {
        setLoading(true);
        let postData = {
            key: props.api,
            schedule_id: scheduleId,
        };
        SftGlobalData.post('scheduler&action=updateNextRun', postData).then(response => {
            if(typeof response.error === 'undefined'){
                loadData();
            } else { 
                props.notify(props.t('errorOccured'), 7500, "top-center", props.theme, 1);
            }
        });
    }

   
    const handleDetailPanelOpen = (rowId) => {
        try{
            if(openDetailPanelRowId[0] === rowId) 
                setOpenDetailPanelRowId([]);
            else
                setOpenDetailPanelRowId([rowId]);
        }catch(e){
            setOpenDetailPanelRowId([rowId]);
        }
        
    };

    const handleDetailPanelClose = () => {
        setOpenDetailPanelRowId(null);
    };

    const translateType = (type) => {
        switch (type) {
            case "D":
                return "Daily";
            case "W":
                return "Weekly";
            case "M":
                return "Monthly";
        }
    }


    return (
        <div style={{display: 'flex', flexDirection: 'column'}} className={(props.screenWidth) < 600 ? 'not_expanded container_content _80perc ' + props.theme + ' container_content_' + props.theme : 'expanded container_content _80perc ' + props.theme + ' container_content_' + props.theme} >
            <div className={"container_list__title " + props.theme}><h2>Scheduler</h2></div>
            <div className='rowContainerCenter _100perc'>
                <DataGridPro
                      apiRef={apiRef}
                      className={'excel_grid ' + props.theme}
                      columns={gridColumns}
                      rows={reports.map((row, index) => {return {
                              id: row.SchedulingID,
                              report_id: row.ReportID,
                              allow_next_run: row.AllowNextRun,
                              name: row.Subject,
                              type: translateType(row.Type),
                              next_run: row.NextRun,
                              count: (typeof row.items !== "undefined" ? row.items?.length : 0),
                              users: (typeof row.items !== "undefined" ? row.items : [])
                          }                          
                      })} 
                      getDetailPanelHeight={({ row }) => 300} // Optional, default is 500px.
                      getDetailPanelContent={({ row }) => (
                            <DetailPanelContent row={row} /> 
                       )}
                      detailPanelExpandedRowIds={openDetailPanelRowId}
                      onDetailPanelExpandedRowIdsChange={(params, event) => {
                        //console.log("params", params);
                        try{
                            if(typeof params[0] !== "undefined")
                                handleDetailPanelOpen(params[0]);
                            else 
                                setOpenDetailPanelRowId([]);
                        }catch(Ex){
                            setOpenDetailPanelRowId([]);
                        }
                      }}
                      onRowClick={(params, event) => {
                            handleDetailPanelOpen(params.id);
                      }}
                      
                      initialState={{ detailPanel: { expandedRowIds: openDetailPanelRowId } }}
                      rowThreshold={0}
                      rowHeight={38}
                      autoHeight={true}
                      loading={loading}
                      pagination={false}
                      />
            </div>
        </div>
    );
}

export default SchedulerScreen;
